var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('MglMap',{staticClass:"first-section",attrs:{"accessToken":_vm.accessToken,"mapStyle":_vm.mapStyle,"mapboxGl":_vm.mapbox,"width":"100%","height":"100%","center":[35.8547, 15.8],"zoom":0},on:{"load":_vm.loaded}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }